<template>
  <BaseButtonSwitch
    v-model="value"
    :options="options"
    :label="label"
    :disabled="disabled"
  />
</template>

<script setup lang="ts">
import { useField } from "vee-validate"
import type { ButtonSwitchOption } from "./BaseButtonSwitch.vue"

const props = defineProps<{
  name: string
  label?: string
  disabled?: boolean
  options: Array<ButtonSwitchOption>
}>()

const { value } = useField<boolean>(toRef(props, "name"))
</script>
